

export const getAuthToken = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = JSON.parse(atob(token.split(".")[1])); // Decode JWT payload
    console.log("Decoded User Data:", decoded); 
    return decoded;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};
